import { useTeacherRetentionHistoryGet } from 'actions/teacher-performance';
import { useParams } from 'react-router-dom';
import { retentionHistoryImportMapper } from '../../helper';

const useLogic = () => {
  const { teacherId } = useParams();

  const { data, isProcessing: isLoading } = useTeacherRetentionHistoryGet(teacherId);

  const retentionHistory = retentionHistoryImportMapper(data ?? {});

  const { retentionFormula, retentionRate, performanceState } = retentionHistory ?? {};

  return {
    retentionFormula,
    isLoading,
    retentionRate,
    performanceState,
  };
};

export default useLogic;
